/**
 * Type definitions shared across the Admin Orders page + components.
 * Real data comes from useOrdersStore + useCustomersStore.
 * Product/category lists are currently empty — they will be sourced
 * from the catalog API when Phase 4 lands.
 */

export type OrderStatus = 'Delivered' | 'In Transit' | 'Pending' | 'Processing' | 'Cancelled';
export type CreditStatus = 'Good' | 'Excellent' | 'Fair';

export interface OrderStats {
  delivered: number;
  inTransit: number;
  pending: number;
  processing: number;
  cancelled: number;
}

export interface OrderItem {
  id: string;
  orderId: string;
  customer: string;
  salesRep: string;
  date: string;
  items: number;
  total: number;
  margin: number;
  status: OrderStatus;
}

export interface CustomerOption {
  id: string;
  name: string;
  area: string;
  creditStatus: CreditStatus;
}

export interface ProductOption {
  id: string;
  name: string;
  category: string;
  price: number;
  stock: number;
}

export const ITEMS_PER_PAGE = 10;

// Empty defaults used by the modal while the catalog API isn't wired yet.
export const categories: string[] = [];
export const productOptions: ProductOption[] = [];

/**
 * Normalize a backend OrderStatus (lowercase enum) to the UI label
 * the table + badge components expect.
 */
export function statusLabel(s: string): OrderStatus {
  const map: Record<string, OrderStatus> = {
    pending: 'Pending',
    confirmed: 'Processing',
    shipped: 'In Transit',
    delivered: 'Delivered',
    invoiced: 'Delivered',
    cancelled: 'Cancelled',
  };
  return map[s] ?? 'Pending';
}
